
import { WelcomeQuestion, CompletionQuestion } from '../questionTypes';

export const welcomeQuestion: WelcomeQuestion = {
  id: "welcome",
  type: "welcome",
  title: "Every succession plan is a unique journey... welcome to your mySuccession Snapshot.",
  description: "This strategic assessment provides immediate insights into your succession planning positioning while establishing the foundation for comprehensive planning development.",
  required: false,
  image: {
    src: "/lovable-uploads/aca40bb5-698e-4c57-b26d-c9838c7e03b6.png",
    alt: "Path Planning Illustration"
  }
};

export const ownerReadinessExitTimelineWelcome: WelcomeQuestion = {
  id: "owner-readiness-exit-timeline-welcome",
  type: "welcome",
  title: "Timeline & Readiness Check-In",
  description: "These brief questions help us get a sense of your personal readiness and the timeframe you envision for succession — so we can align your goals with a practical next step forward.",
  required: false,
  image: {
    src: "/lovable-uploads/d895ef5e-3be3-49e9-915e-e1dd48b7da03.png",
    alt: "Planning Calendar Illustration"
  }
};

export const completionQuestion: CompletionQuestion = {
  id: "completion",
  type: "completion",
  title: "Thanks for sharing where you are today — we've got a great starting point",
  description: "We're now developing a custom guide for your Next Steps based on your answers and have identified key areas of opportunity we can build together.",
  required: false,
};

export const ownerReadinessCompletionQuestion: CompletionQuestion = {
  id: "owner-readiness-completion",
  type: "completion", 
  title: "Personal Readiness Assessment Complete",
  description: "Your responses provide valuable insights into your readiness for succession planning.",
  required: false,
};

export const businessProfileCompletionQuestion: CompletionQuestion = {
  id: "business-profile-completion",
  type: "completion",
  title: "Business Profile Complete!",
  description: "Your comprehensive business profile is now ready for personalized succession insights.",
  required: false,
};

export const governanceFamilyWelcome: WelcomeQuestion = {
  id: "governance-family-welcome",
  type: "welcome",
  title: "Governance & Family Dynamics",
  description: "This assessment evaluates your practice's governance structure, family involvement, communication patterns, insurance coverage, estate planning integration, and emergency preparedness. Some questions touch on sensitive family dynamics — there are no wrong answers, only your honest assessment of where things stand today.",
  required: false,
  image: {
    src: "/lovable-uploads/d895ef5e-3be3-49e9-915e-e1dd48b7da03.png",
    alt: "Governance & Family Dynamics Illustration"
  }
};

export const governanceFamilyCompletionQuestion: CompletionQuestion = {
  id: "governance-family-completion",
  type: "completion",
  title: "Governance & Family Dynamics Complete",
  description: "You've completed a thorough review of your governance structure, family dynamics, and emergency preparedness. These insights will directly inform your succession plan recommendations and highlight areas where professional facilitation or legal review may add significant value.",
  required: false,
};
